import { render, staticRenderFns } from "./unitAddress.vue?vue&type=template&id=2029d3ae&scoped=true"
import script from "./unitAddress.vue?vue&type=script&lang=js"
export * from "./unitAddress.vue?vue&type=script&lang=js"
import style0 from "./unitAddress.vue?vue&type=style&index=0&id=2029d3ae&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2029d3ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2029d3ae')) {
      api.createRecord('2029d3ae', component.options)
    } else {
      api.reload('2029d3ae', component.options)
    }
    module.hot.accept("./unitAddress.vue?vue&type=template&id=2029d3ae&scoped=true", function () {
      api.rerender('2029d3ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/settlementUnit/unitAddress.vue"
export default component.exports